var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"text-wrapper"},[_c('span',{staticClass:"small-text"},[_vm._v(_vm._s(_vm.$t('contentWizard.preview.oneMoment')))]),_c('span',{staticClass:"large-text"},[_vm._v(_vm._s(_vm.$t('contentWizard.preview.htmlIsRendering')))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinning-bar"},[_c('div',{staticClass:"spinner"})])
}]

export { render, staticRenderFns }